import eventEmitter3 from "eventemitter3";

type RosettaEvents = "showPaywall";

export const eventEmitter = new eventEmitter3<RosettaEvents>();
